export const getDateKey = (date: number, dateHash: Record<string, number>) => {
  const dateObj = new Date(date);
  const monthNumber = dateObj.getMonth() + 1;
  const abbrYear = dateObj.getFullYear().toString().substring(2, 4);

  let dateKey = `${monthNumber}/${abbrYear}`;
  if (dateHash[dateKey]) {
    dateHash[dateKey] += 1;
    dateKey = `${dateKey} (${dateHash[dateKey]})`;
  } else {
    dateHash[dateKey] = 1;
  }

  return dateKey;
};



// WEBPACK FOOTER //
// ./src/features/director/pages/SurveyDataCenter/hooks/utils/getDateKey/getDateKey.ts